import type { ISalesCounterpart } from 'models/ISalesCounterpart';

export function isSameClient(
  newClient: ISalesCounterpart | undefined,
  oldClientBdrId: string | undefined,
  oldClientEliotCode: string | undefined,
) {
  if (oldClientBdrId === undefined && oldClientEliotCode === undefined) {
    return false;
  }
  if (newClient === undefined) {
    return false;
  }
  return newClient?.eliotCode === oldClientEliotCode || newClient?.id === oldClientBdrId;
}
